<template>
  <div class="main_container">
    <van-nav-bar title="我的" :fixed="true" />
    <div class="body" v-if="userInfo">
      <div class="set_group">
        <van-cell-group>
          <van-cell :value="userInfo.userName">
            <template slot="title">
              <i class="iconfont icon-user icon-back"></i>
              <span class="van-cell-text">用户名</span>
            </template>
          </van-cell>

          <van-cell :value="userInfo.realName">
            <template slot="title">
              <i class="iconfont icon-nicheng icon-back" style="background: #57c85a"></i>
              <span class="van-cell-text">昵称</span>
            </template>
          </van-cell>
        </van-cell-group>
        <!-- <van-cell :value="'1.0.2'">
            <template slot="title">
              <i class="iconfont icon-banbenhao icon-back" style="background: rgb(157, 195, 65)"></i>
              <span class="van-cell-text">版本号</span>
            </template>
        </van-cell>-->
        <!-- </van-cell-group> -->
      </div>

      <div class="set_group">
        <van-cell-group>
          <van-cell :value="app_version">
            <template slot="title">
              <i class="iconfont icon-banbenhao icon-back" style="background: #30b7c0"></i>
              <span class="van-cell-text">版本号</span>
            </template>
          </van-cell>

          <van-cell @click="checkVersion" is-link>
            <template slot="title">
              <i class="iconfont icon-jianchagengxin icon-back" style="background: #288bdd"></i>
              <span class="van-cell-text">检查更新</span>
            </template>
          </van-cell>

          <!-- <van-cell @click="clearCache()" is-link>
            <template slot="title">
              <i class="iconfont icon-banbenhao icon-back" style="background: rgb(75, 175, 78)"></i>
              <span class="van-cell-text">清除缓存</span>
            </template>
          </van-cell>-->

          <van-cell @click="quit()" is-link v-if="userInfo.userName !== 'rzwz_default'">
            <template slot="title">
              <i class="iconfont icon-tuichu icon-back" style="background: #328ffa"></i>
              <span class="van-cell-text">退出</span>
            </template>
          </van-cell>

          <van-cell @click="loginOther()" is-link v-else>
            <template slot="title">
              <i class="iconfont icon-tuichu icon-back" style="background: #328ffa"></i>
              <span class="van-cell-text">登录</span>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { checkVersion } from "../../store/";
import { Toast, Dialog } from "vant";
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
  computed: {
    scHeight: function () {
      return "" + document.documentElement.clientHeight - 138;
    },
    ...mapState(["userInfo", "loginAsDefault", "loginType"]),
    app_version() {
      if (window.app_version) {
        return window.app_version;
      } else {
        return "";
      }
    },
  },
  methods: {
    checkVersion() {
      checkVersion(true);
    },
    quit() {
      localStorage.setItem("yc_token", "");
      this.$store.commit("setToken", "");

      if (this.loginType === "default") {
        this.$store.dispatch("loginAsDefault").then((x) => {
          this.$store.commit("setLoginType", "default");
          this.$store.dispatch("init");
        });
      } else {
        this.$router.replace({ path: "/login" });
      }
      // window.JPush.deleteAlias(
      //     { sequence: 1 },
      //     function(result) {
      //         console.log(JSON.stringify(result));
      //     },
      //     function(error) {
      //         console.log(error.code);
      //     }
      // );
    },
    loginOther() {
      this.$router.push({ path: "/login" });
    },
    clearCache() {
      console.log("clearCache");
      document.addEventListener("deviceready", onDeviceReady);
      function onDeviceReady() {
        var success = function (status) {
          console.log(status);
          Toast.success("清除成功");
        };
        var error = function (status) {
          console.log(status);
          Toast.fail("清除失败");
        };
        window.cache.clear(success, error);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  height: 33px;
  border-bottom: 1px solid #e3e3e3;
  text-align: center;
  padding-top: 10px;
  font-size: 18px;
}

.content {
  height: 40px;
  line-height: 40px !important;
  padding-left: 10px;
  display: inline-block;
  width: 67px;
}
.quit {
  position: absolute;
  border-bottom: 1px solid #c6c6c6;
  border-top: 1px solid #c6c6c6;
  width: 97%;
  margin: 0 auto;
  height: 45px;
  bottom: 80px;
  transform: translate(-50%, -10%);
  left: 50%;
  text-align: center;
}
.set_group {
  border-top: 1px solid #f3f3f3;
}
.main_container {
  height: 100%;
  background: #f3f3f3;
}
</style>



// WEBPACK FOOTER //
// src/pages/set/set.vue